import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { Reaction } from "../types";
import { WorkplaceReviewCommentAuthorInfo } from "./CommentAuthorInfo";
import { WorkplaceReviewCommentLikesButton } from "./LikesButton";
import { WorkplaceReviewCommentRepliesAndLikesWrapper } from "./RepliesAndLikesWrapper";
import { WorkplaceReviewCommentRepliesCountIcon } from "./RepliesCountIcon";
import { WorkplaceReviewAnonymizeIcon } from "./WorkplaceReviewAnonymizeIcon";
import { WorkplaceReviewRemoveIcon } from "./WorkplaceReviewRemoveIcon";

interface CardStandardLayoutProps {
  comment: WorkplaceCommentType;
  workplaceId: string;
  viewerIsAuthor: boolean;
  profilePictureUrl?: string;
  isLoadingProfilePicture: boolean;
  createdAt: Date;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  onAnonymize: () => void;
  onRemove: () => void;
}

export function CardStandardLayout(props: CardStandardLayoutProps) {
  const {
    comment,
    workplaceId,
    viewerIsAuthor,
    profilePictureUrl,
    isLoadingProfilePicture,
    createdAt,
    onLikeChanged,
    onAnonymize,
    onRemove,
  } = props;

  const { workerInfo, text, aggregates, workerReaction } = comment.attributes;
  const { name: workerName } = workerInfo;
  const { totalLikes, totalReplies } = aggregates;

  return (
    <>
      <Text variant="body2" sx={{ paddingBottom: 6 }}>
        {text}
      </Text>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <WorkplaceReviewCommentAuthorInfo
          workerName={workerName}
          profilePictureUrl={profilePictureUrl}
          isLoadingProfilePicture={isLoadingProfilePicture}
          createdAt={createdAt}
        />

        <WorkplaceReviewCommentRepliesAndLikesWrapper>
          {viewerIsAuthor && <WorkplaceReviewAnonymizeIcon onAnonymize={onAnonymize} />}

          <WorkplaceReviewCommentRepliesCountIcon count={totalReplies} />

          <WorkplaceReviewCommentLikesButton
            workplaceId={workplaceId}
            commentId={comment.id}
            isLiked={workerReaction === Reaction.LIKE}
            count={totalLikes}
            onLikeChanged={onLikeChanged}
          />

          {viewerIsAuthor && <WorkplaceReviewRemoveIcon onRemove={onRemove} />}
        </WorkplaceReviewCommentRepliesAndLikesWrapper>
      </Stack>
    </>
  );
}
